import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { Auth } from "aws-amplify";
import { isEmpty } from "lodash";

import Alert from "components/shared/common/alert";
import { updateUserAttributes } from "components/shared/mailchimp";

const ProfileSettings = ({
  history,
  currentUser,
  handleIsLoading,
  handleSetCurrentUser
}) => {
  const [userDetails, setUserDetails] = useState({
    first_name: "",
    last_name: "",
    password: "",
    old_password: "",
    confirm_password: ""
  });

  useEffect(() => {
    const userName = currentUser?.username?.split(" ");
    userName &&
      setUserDetails((prev) => ({
        ...prev,
        first_name: userName[0],
        last_name: userName[1] || ""
      }));
  }, [JSON.stringify(currentUser)]);

  const isUsername = () => {
    const userName = currentUser?.username?.split(" ");
    if (
      !userName ||
      isEmpty(userDetails.first_name) ||
      (userDetails.first_name === userName[0] &&
        userDetails.last_name === userName[1])
    )
      return false;
    return true;
  };

  const isPassword = () =>
    !isEmpty(userDetails.old_password) &&
    !isEmpty(userDetails.password) &&
    !isEmpty(userDetails.confirm_password);

  const handleInputChange = (value, name) =>
    setUserDetails((prev) => ({ ...prev, [name]: value }));

  const changeUsername = async () => {
    try {
      const newUsername = `${userDetails.first_name} ${userDetails.last_name}`;
      await updateUserAttributes({ name: newUsername }, (res, err) => {
        if (res === "SUCCESS") {
          handleSetCurrentUser("username", newUsername);
          !isPassword() && Alert(200, "Profile details updated successfully");
        }
      });
    } catch (error) {
      console.log("Error changing username: ", error);
    }
  };

  const changePassword = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true
      });
      const data = await Auth.changePassword(
        user,
        userDetails.old_password,
        userDetails.confirm_password
      );
      if (data === "SUCCESS") {
        Alert(200, "Profile details updated successfully");
      }
    } catch (error) {
      if (error.code === "NotAuthorizedException")
        Alert(400, "Old password is incorrect");
      console.log("Error changing password: ", error);
    }
  };

  const handleSaveDetails = async () => {
    handleIsLoading(true);
    try {
      if (isUsername()) await changeUsername();

      if (isPassword()) {
        if (userDetails.password.length < 8) {
          Alert(400, "Password must be 8 characters");
        } else if (userDetails.password !== userDetails.confirm_password) {
          Alert(400, "Passwords must be the same");
        } else {
          await changePassword();
        }
      }
    } catch (error) {
      console.log("Error saving details: ", error);
    } finally {
      handleIsLoading(false);
    }
  };

  return (
    <div className="profile-setting">
      <div className="header">
        <h2>profile setting</h2>
        <button
          className="save-btn"
          onClick={handleSaveDetails}
          disabled={!isUsername() && !isPassword()}
        >
          Save
        </button>
      </div>
      <h2 className="heading">Manage Details</h2>
      <p className="txt">
        Update your name, password, and where to send emails to.
      </p>
      <Row>
        <Col md={6} lg={6}>
          <div className="mb-4">
            <input
              type="text"
              name="first_name"
              placeholder="First Name"
              value={userDetails.first_name}
              className="form-control input-1"
              onChange={(e) => handleInputChange(e.target.value, e.target.name)}
            />
          </div>
        </Col>
        <Col md={6} lg={6}>
          <div className="mb-4">
            <input
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={userDetails.last_name}
              className="form-control input-1"
              onChange={(e) => handleInputChange(e.target.value, e.target.name)}
            />
          </div>
        </Col>
      </Row>
      <div className="line" />
      <div className="mb-4">
        <label htmlFor="">Email</label>
        <input
          disabled
          type="email"
          onChange={() => {}}
          value={currentUser.email}
          className="form-control input-2"
        />
      </div>
      <div className="line2" />
      <div className="mb-4">
        <label htmlFor="">Update Password</label>
        <input
          type="password"
          name="old_password"
          placeholder="Old Password"
          autoComplete="new-password"
          value={userDetails.old_password}
          className="form-control input-1"
          onChange={(e) => handleInputChange(e.target.value, e.target.name)}
        />
        <div className="line2 old-password" />
        <input
          type="password"
          name="password"
          placeholder="New Password"
          autoComplete="new-password"
          value={userDetails.password}
          className="form-control input-1"
          onChange={(e) => handleInputChange(e.target.value, e.target.name)}
        />
      </div>
      <div className="mb-4">
        <input
          type="password"
          name="confirm_password"
          placeholder="Confirm Password"
          value={userDetails.confirm_password}
          className="form-control input-1"
          onChange={(e) => handleInputChange(e.target.value, e.target.name)}
        />
      </div>
      <div className="line2"></div>
      <p className="sus-txt">
        If you wish to suspend to delete your account,{" "}
        <span onClick={() => history.push("/delete_account")}>Click Here</span>.
      </p>
    </div>
  );
};

export default ProfileSettings;
